<template>
    <rkm-overlay>
        <rkm-layout-body title="Pontos de Referência">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-ponto-create' })"
                    autorize="store-transporte-paciente-ponto"
                    color="primary"
                >
                    Cadastrar ponto
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/ponto/List'

export default {
    components: { List },
}
</script>